import { render, staticRenderFns } from "./importStudents.vue?vue&type=template&id=2f61b5ee&"
import script from "./importStudents.vue?vue&type=script&lang=js&"
export * from "./importStudents.vue?vue&type=script&lang=js&"
import style0 from "./importStudents.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports